module.exports = __webpack_public_path__ + "static/img/page0-btn.579b6c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/page0-btn.png
// module id = WIUt
// module chunks = 1